import { z } from "zod";
import { COLORS } from "../../colors";

export const fillPatterns = [
	"solid",
	"hatch",
	"crosshatch",
	"dots",
	"grid",
	"stripes",
	"checker",
	"waves",
	"plus",
	"none",
] as const;
export type FillPattern = (typeof fillPatterns)[number];

export const polygonValuesFormSchema = z.object({
	text: z.string().optional(),
	fillColor: z.enum(COLORS),
	strokeColor: z.enum(COLORS),
	fillPattern: z.enum(fillPatterns),
});

export type PolygonValuesFormSchema = z.infer<typeof polygonValuesFormSchema>;
